import { render, staticRenderFns } from "./Mform.vue?vue&type=template&id=169a97b6&scoped=true"
import script from "./Mform.vue?vue&type=script&lang=js"
export * from "./Mform.vue?vue&type=script&lang=js"
import style0 from "./Mform.vue?vue&type=style&index=0&id=169a97b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169a97b6",
  null
  
)

export default component.exports